import { Text } from "@fluentui/react";
import { Toggle } from "@fluentui/react";
import { WeatherMoon24Regular } from "@fluentui/react-icons";
import { WeatherSunny24Regular } from "@fluentui/react-icons";

import styles from "./DarkModeSwitch.module.css";

interface Props {
    className?: string;
    onChange: () => void;
    isDarkMode?: boolean;
}

export const DarkModeSwitch = ({ className, onChange, isDarkMode }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <WeatherMoon24Regular />
            <Toggle className={styles.darkModeSwitch} onClick={onChange} />
            <Text className={isDarkMode ? styles.textDark : styles.text}>{"Dark Mode"}</Text>
        </div>
    );
};
